import React from 'react'
import styles from './Features.module.css';

const GridItem = ({ icon, title, desc }) => <div className={styles.gridItem}>
  <img className={styles.icon} src={icon} height={24} width={24}/>
  <div className={styles.gridItemTitle}>{title}</div>
  <div className={styles.gridItemDesc}>{desc}</div>
</div>

const Features = () => <div className={styles.features}>
  <div className="text-start flex-grow-1">
    <div className={styles.title}>
      <span style={{ color: '#454545', fontWeight: 'bold' }}>Sharing work</span>
      <span style={{ color: 'gray' }}> was<br/> <i>too complicated, </i></span><br/>
      <span className="color-purple bold">so we fixed it</span>
    </div>
    <div className="mt-5">
      <span className="indie-flower-font font-22 color-purple">And more...</span>
      <div className="font-18 font-weight-light mt-2">
        <img src="assets/icons/tick.png" height={20} width={20} className="me-3 op-6"/>
        Document collections
      </div>
      <div className="font-18 font-weight-light mt-2">
        <img src="assets/icons/tick.png" height={20} width={20} className="me-3 op-6"/>
        Fast, global hosting (CDN)
      </div>
      <div className="font-18 font-weight-light mt-2">
        <img src="assets/icons/tick.png" height={20} width={20} className="me-3 op-6"/>
        Security covered (SSLs included)
      </div>
    </div>
  </div>
  <div className={styles.grid}>
    <GridItem icon="assets/icons/hand-pointing-upward.png" title="Drag & drop files" desc="Easily drag & drop your files to share your work." />
    <GridItem icon="assets/icons/signal-bars.png" title="Track your impact" desc="Through automatic visitor analytics." />
    <GridItem icon="assets/icons/asterisk.png" title="Stay on brand" desc="Connect your own custom domain (web address)." />
    <GridItem  icon="assets/icons/padlock.png"title="Keep it private" desc="Password protect your work to restrict access." />
  </div>
</div>

export default Features;